import $ from 'jquery';

$('.footer-navigation__page--level-1.footer-navigation__page--subpages').on('click', function () {
    $(this).children('.footer-navigation__list').toggleClass('footer-navigation__list--show');
    $(this).toggleClass('footer-navigation__page--active');
    $(this).siblings('.footer-navigation__page').removeClass('footer-navigation__page--active')
    $(this).siblings('.footer-navigation__page').find('.footer-navigation__list').removeClass('footer-navigation__list--show')
})
